import { render, staticRenderFns } from "./VisitorMetaReferralsCard.vue?vue&type=template&id=3ffc1ba4&scoped=true"
import script from "./VisitorMetaReferralsCard.vue?vue&type=script&lang=js"
export * from "./VisitorMetaReferralsCard.vue?vue&type=script&lang=js"
import style0 from "./VisitorMetaReferralsCard.vue?vue&type=style&index=0&id=3ffc1ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc1ba4",
  null
  
)

export default component.exports